import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 0.9C12 0.402944 12.4035 -0.00351234 12.8992 0.0337289C14.9559 0.188257 16.9435 0.870892 18.6668 2.02236C20.6402 3.34094 22.1783 5.21509 23.0866 7.4078C23.9948 9.60051 24.2324 12.0133 23.7694 14.3411C23.3064 16.6689 22.1635 18.8071 20.4853 20.4853C18.8071 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0866C5.21509 22.1783 3.34094 20.6402 2.02236 18.6668C0.870892 16.9435 0.188257 14.9559 0.0337289 12.8992C-0.00351233 12.4035 0.402944 12 0.9 12C1.39706 12 1.79588 12.4037 1.83968 12.8989C1.99008 14.5991 2.56539 16.2396 3.51901 17.6668C4.6398 19.3442 6.23282 20.6516 8.09663 21.4236C9.96043 22.1956 12.0113 22.3976 13.9899 22.004C15.9685 21.6104 17.786 20.639 19.2125 19.2125C20.639 17.786 21.6104 15.9685 22.004 13.9899C22.3976 12.0113 22.1956 9.96043 21.4236 8.09663C20.6516 6.23282 19.3442 4.6398 17.6668 3.51901C16.2396 2.56539 14.5991 1.99008 12.8989 1.83968C12.4037 1.79588 12 1.39706 12 0.9Z",
		fill: "currentColor"
	})
});
export default SvgEllipse;
